import { RootState } from '../reducers/state'
import { ApisActions } from '../actions/apis'
import { createReducer } from '@reduxjs/toolkit'
import { IccSyslogApi } from 'api/api/IccSyslogApi'
import { IccUserApi } from 'api/api/IccUserApi'

const initialState: RootState.ApiState = {} as RootState.ApiState

export const apisReducer = createReducer(initialState, (builder) => {
  builder.addCase(ApisActions.login, (state, action) =>
    action.payload
      ? {
          syslogApi: new IccSyslogApi(action.payload.host, { Authorization: `Basic ${btoa(`${action.payload.username}:${action.payload.password}`)}` }),
          userApi: new IccUserApi(action.payload.host, { Authorization: `Basic ${btoa(`${action.payload.username}:${action.payload.password}`)}` }),
        }
      : state,
  )
})
